// extracted by mini-css-extract-plugin
module.exports = {"Ribbon":"Ribbon_Ribbon__1TyZO","RibbonHot":"Ribbon_RibbonHot__1hGQy","RibbonSale":"Ribbon_RibbonSale__p__TM"};